<template>
  <div class="profile">
    <div class="box">
      <div class="main">
        <el-form :model="form" :rules="rules" ref="form" class="form" label-width="80px">
          <el-form-item label="原密码" prop="old">
            <el-input type="password" v-model="form.old" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input :type="passwordType" class="pwd" v-model="form.pass" placeholder="请输入新密码，区分大小写"></el-input>
            <div class="show-pwd" @click="showPwd">
              <svg-icon icon-class="eye" />
            </div>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="action">
        <el-button type="primary" style="width:200px" @click="doChange">修改密码</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        old: '',
        pass: '',
        checkPass: ''
      },
      passwordType: 'password',
      rules: {
        old: [
          {required: true, message: '请输入原密码', trigger: 'blur'}
        ],
        pass: [
          {required: true, message: '请输入新密码', trigger: 'blur'}
        ],
        checkPass: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    doChange() {
      const _t = this
      _t.$refs['form'].validate((valid) => {
        if (valid) {
          const data = {
            old: _t.form.old.trim(),
            pwd: _t.form.pass.trim()
          }
          _t.$http.post('/api/auth/change-pwd', data).then(resp => {
            if (resp.code === 0) {
              _t.form.old = ''
              _t.form.pass = ''
              _t.form.checkPass = ''
              _t.$message.success(resp.msg)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.profile {
  text-align: center;
  color: #606266;
}
.box {
  max-width: 400px;
  padding: 20px;
  .title {
    font-size: 20px;
    margin: 0 0 20px 0;
  }
  .form {
    width: 100%;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .main {
    margin: 40px 0;
  }
}
</style>

